export default {
  meta: {
    title: '集客点详情',
  }
};
